import classnames from 'classnames/bind'

// Libs

// Components

// Styles
import styles from './style.module.scss'

// Lotties

const cx = classnames.bind(styles)

const Alert = (props: { text: string }) => {
  const { text } = props

  return (
    <div className={cx('alert')}>
      <p className={cx('alert-text')}>{text}</p>
    </div>
  )
}

export default Alert
